import React from 'react';
import moment from 'moment';

const SrDayOnMarketTick = ({ x, y, data, payload }) => {
  const entry = data[payload.index];
  const showDate =
    entry.daysOnMarket % 7 === 0 || entry.daysOnMarket === 1 || data.length === payload.index + 1;

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="end"
        fontFamily="Greycliff"
        fontSize="16px"
        fill="rgba(0, 0, 0, 0.4)"
      >
        {payload.value}
      </text>
      {showDate && (
        <text
          x={4}
          y={16}
          dy={16}
          textAnchor="end"
          fontFamily="Greycliff"
          fontSize="10px"
          fill="rgba(0, 0, 0, 0.4)"
        >
          {moment(entry.date).format('MMM D')}
        </text>
      )}
    </g>
  );
};

SrDayOnMarketTick.displayName = 'SrDayOnMarketTick';

export default SrDayOnMarketTick;
